"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PDPProductFeaturesRating = void 0;
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const components_common_icon_1 = require("@hotelplan/components.common.icon");
const components_common_rating_1 = require("@hotelplan/components.common.rating");
const libs_mappers_1 = require("@hotelplan/libs.mappers");
const util_theme_sxc_1 = require("@hotelplan/util.theme.sxc");
const FeaturesRatingWrapper = styled_components_1.default.div((0, util_theme_sxc_1.sx2CssThemeFn)({
    mb: [2, 3],
}));
const FeaturesHeadingWrapper = styled_components_1.default.div(({ theme }) => theme.product.featuresHeadingWrapper);
const currentRatingItemStyles = {
    backgroundColor: 'black',
    height: ['14px', '14px', '15px'],
    width: ['14px', '14px', '15px'],
    borderRadius: 'circle',
    '&:not(:last-child)': {
        mr: 1,
    },
};
const FeaturesRating = (0, styled_components_1.default)(components_common_rating_1.Rating)(({ theme: { colors } }) => (0, util_theme_sxc_1.sx2CssThemeFn)({
    '.rating': Object.assign({}, currentRatingItemStyles),
    '.halfWayRating': Object.assign(Object.assign({}, currentRatingItemStyles), { background: 'linear-gradient( 90deg, black, black 50%, #E1E1E1 50% )' }),
    '.remainRating': Object.assign(Object.assign({}, currentRatingItemStyles), { backgroundColor: colors.lightGreyFirst }),
}));
const PDPProductFeaturesRating = ({ featuresRating, }) => {
    const featuresRatingResult = featuresRating.filter(item => item.rating);
    return (react_1.default.createElement(react_1.default.Fragment, null, featuresRatingResult.map(({ id, name, rating }) => {
        const currentRating = (rating || 0) / 10;
        return (react_1.default.createElement(FeaturesRatingWrapper, { key: id },
            react_1.default.createElement(FeaturesHeadingWrapper, null,
                react_1.default.createElement(components_common_icon_1.Icon, { name: (0, libs_mappers_1.mapFeatureNameToIcon)(id) }),
                react_1.default.createElement("h3", { className: "features-heading" }, name)),
            react_1.default.createElement(FeaturesRating, { maxRating: 5, rating: currentRating })));
    })));
};
exports.PDPProductFeaturesRating = PDPProductFeaturesRating;
const FeaturesListWrapper = styled_components_1.default.div(({ theme }) => theme.product.featuresListWrapper);
// @todo: Make it simpler
const FeatureIcon = (0, styled_components_1.default)(components_common_icon_1.Icon).attrs(({ enabled }) => ({
    name: enabled ? 'success' : 'cancel',
}))(({ enabled, disabledFeatureColor, theme: { colors } }) => ({
    paddingTop: '1px',
    color: enabled ? colors.success : disabledFeatureColor || colors.primary,
}));
const PDPProductFeatures = ({ attributes, disabledFeatureColor, }) => {
    return (react_1.default.createElement(react_1.default.Fragment, null, attributes.map(({ id, name, features }) => {
        const icon = (0, libs_mappers_1.mapFeatureNameToIcon)(id);
        return (react_1.default.createElement(FeaturesListWrapper, { key: id },
            react_1.default.createElement(FeaturesHeadingWrapper, null,
                react_1.default.createElement(components_common_icon_1.Icon, { name: icon }),
                react_1.default.createElement("h3", { className: "features-heading" }, name)),
            react_1.default.createElement("ul", { className: "features-list" }, features.map((item, i) => {
                return (react_1.default.createElement("li", { className: "feature-item", key: i },
                    react_1.default.createElement("span", { className: "feature-icon-wrapper" },
                        react_1.default.createElement(FeatureIcon, { enabled: !!item.enabled, disabledFeatureColor: disabledFeatureColor })),
                    react_1.default.createElement("span", null, item.name)));
            }))));
    })));
};
exports.default = PDPProductFeatures;
//# sourceMappingURL=ProductFeatures.js.map